declare global {
  interface Window {
    _env_?: {
      [key: string]: string;
    };
  }
}

const getEnv = (key: string, defaultValue: string = ""): string => {
  return window._env_?.[key] || process.env[key] || defaultValue;
};

const apiServer = getEnv("REACT_APP_API_SERVER");
const cleanApiServer = apiServer ? apiServer.replace(/\/+$/, "") : "";

export const CONFIG = {
  API_SERVER: cleanApiServer,
  DEV_MODE: getEnv("REACT_APP_DEV_MODE") === "true",
  DEV_MODE_ALLOWED_EMAILS: getEnv("REACT_APP_DEV_MODE_ALLOWED_EMAILS"),
  AUTH_CLIENT_ID: getEnv("REACT_APP_AUTH_CLIENT_ID"),
  AUTH_TENANT_ID: getEnv("REACT_APP_AUTH_TENANT_ID"),
  REDIRECT_URI: getEnv("REACT_APP_REDIRECT_URI"),
  AUTH_SCOPE: getEnv("REACT_APP_AUTH_SCOPE"),
};
